"use client";

import React, { useEffect, useRef, useState } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import axios from "axios";

export default function UniversityPartners() {
  const [universityPartnerData, setUniversityPartnerData] = useState([]);
  const swiperRef = useRef();

  useEffect(() => {
    async function fetchUniversityPartner() {
      const apiUrl = process.env.REACT_APP_AIRTABLE_URL;
      const token = process.env.REACT_APP_AIRTABLE_TOKEN;

      try {
        axios
          .get(`${apiUrl}/university`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            console.log("Response data:", response.data);
            setUniversityPartnerData(response.data.records);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
        // const result = await getUniversityPartners();
        // setUniversityPartnerData(result.records);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchUniversityPartner();
  }, []);

  return (
    <>
      <div className="relative max-w-[1380px] mx-auto mt-9 px-4">
        {/* Blur overlays on left and right */}
        <div className="absolute left-0 top-0 h-full w-12 z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none rounded-md" />
        <div className="absolute right-0 top-0 h-full w-12 z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none rounded-md" />

        {/* Swiper Carousel */}
        <div className="flex items-center justify-center">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            spaceBetween={4} // reduce the gap
            loop={true}
            speed={4000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: { slidesPerView: 3 },
              480: { slidesPerView: 4 },
              768: { slidesPerView: 5 },
              1024: { slidesPerView: 6 },
            }}
            modules={[Autoplay]}
          >
            {universityPartnerData.map((up, index) => (
              <SwiperSlide key={index} className="py-2 px-1">
                <div className="h-[80px] w-full flex items-center justify-center">
                  <img
                    className="h-[80px] max-w-[100px] object-contain"
                    src={up.fields.logo[0].thumbnails.full.url || ""}
                    alt={up.fields.name}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>

  );
}
